var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"survey-container"}},[_c('usabilla-container',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var usabillaIsDoneLoading = ref.usabillaIsDoneLoading;
var widgetMounted = ref.widgetMounted;
return [(usabillaIsDoneLoading)?_c('usabilla-widget',{attrs:{"widget-id":_vm.widgetId,"order-reference":_vm.referenceOrderID},on:{"on-widget-mounted":widgetMounted}}):_vm._e()]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }